<div class="header-bar">
  <h1>Organisation Interaction Categories</h1>
</div>
<div class="content-container">
  <div class="filterPanel">
    <div class="flex">
      <div class="">
        <span class="md-inputfield filterItem" style="min-width: 300px">
          <input
            name="reason"
            [(ngModel)]="categoryName"
            pInputText
            maxlength="32"
            placeholder="Interaction Category Name"
          />
        </span>
      </div>

      <div class="">
        <button pButton type="submit" label="Add Category" (click)="addCategory()"></button>
      </div>
    </div>
  </div>

  <p-table
    [value]="categories"
    [responsive]="true"
    resizableColumns="true"
    class="fixed-table"
    (onEditComplete)="onEditComplete($event)"
    selectionMode="none"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">Category</th>
        <th pSortableColumn="updatedDate">Updated</th>
        <th pSortableColumn="updatedByUser">Updated By</th>
        <th pSortableColumn="inactiveDate">Inactive Date</th>
        <th style="width: 100px"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td [pEditableColumn]="item" [pEditableColumnField]="'name'">
          <p-cellEditor>
            <ng-template pTemplate="output">
              <div style="font-weight: bold">{{ item.name }}</div>
            </ng-template>
            <ng-template pTemplate="input">
              <span style="padding: 0 10px">
                <input [(ngModel)]="item.name" pInputText />
              </span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td>{{ item.updatedDate | datex : 'ddd DD MMM HH:mm' }}</td>
        <td>{{ item.updatedByUser }}</td>
        <td>
          <div pTooltip="This category is inactive" *ngIf="item.inactiveDate" style="width: 100%">
            {{ item.inactiveDate | date : 'dd/MM/yyy HH:mm' }}
          </div>
        </td>
        <td style="text-align: center">
          <button
            *ngIf="!item.inactiveDate"
            type="button"
            pButton
            (click)="setCategoryActivation(item)"
            icon="fa ui-icon-lock-open"
            pTooltip="Deactivate Category"
          ></button>
          <button
            *ngIf="item.inactiveDate"
            type="button"
            pButton
            (click)="setCategoryActivation(item)"
            icon="fa ui-icon-lock"
            pTooltip="Reactivate Category"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!--- DEPRECATED DATATABLES --
  <p-dataTabl [value]='categories' [responsive]='true' resizableColumns='true' class='fixed-table'
               selectionMode='none'>
    <p-column field='' header='Category' [sortable]='false' [editable]='true'>
      <ng-template pTemplate='body' let-item='rowData'>
        <div>{{ item.name }}</div>
      </ng-template>
    </p-column>
    <p-column field="updatedDate" header="Updated" [sortable]="tru" [editable]="false">
      <ng-template pTemplate="body" let-item="rowData">
        {{ item.updatedDate | datex:'ddd DD MMM HH:mm' }}
      </ng-template>
    </p-column>
    <p-column field="updatedByUser" header="Updated By" [sortable]="false" [editable]="false">
      <ng-template pTemplate="body" let-item="rowData">
        {{ item.updatedByUser }}
      </ng-template>
    </p-column>

    <p-column field="inactiveDate" header="Inactive Date" [sortable]="tru" [editable]="false" [style]="{'width': '135px'}">
      <ng-template pTemplate="body" let-item="rowData">
        <div pTooltip="This category is inactive" *ngIf="item.inactiveDate" style="width: 100%">{{item.inactiveDate | date:'dd/MM/yyy HH:mm'}}</div>
        <div pTooltip="This category is active" *ngIf="!item.inactiveDate" style="width: 100%">&nbsp;</div>
      </ng-template>
    </p-column>

    <p-column [style]="{'text-align': 'center', 'width': '76px' }">
      <ng-template let-item="rowData" pTemplate="body">
        <button *ngIf="!item.inactiveDate" type="button"
                pButton (click)="setCategoryActivation(item)" icon="fa ui-icon-lock-open" pTooltip="Deactivate Category"></button>
        <button *ngIf="item.inactiveDate" type="button"
                pButton (click)="setCategoryActivation(item)" icon="fa ui-icon-lock" pTooltip="Reactivate Category"></button>
      </ng-template>
    </p-column>
  </p-dataTable>

  -->
</div>
